import {styled} from "@stitches/react";

export const TableWrapper = styled("table", {
    fontFamily: "Manrope",
    borderCollapse: "separate",
    borderSpacing: "0 7px",
});

export const TableCell = styled("td", {
    fontSize: 14,
    color: "#0E1117",
    padding: "2px 16px",
    textAlign: 'center',
    // Применение закругления для первой ячейки строки
    "&:first-child": {
        borderRadius: '12px 0 0 12px',
    },
    // Применение закругления для последней ячейки строки
    "&:last-child": {
        borderRadius: '0 12px 12px 0',
    },
});

export const TableRowItem = styled("tr", {
    cursor: "pointer",
    backgroundColor: "#FFFFFF",
    height: 48,
    border: '1px solid transparent',
    transition: 'all ease 0.3s',
    padding: 5,
    "&:hover": {
        backgroundColor: "#FFFFFF",
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.10) !important',
    }
});


export const TableHeaderCell = styled("th", {
    backgroundColor: "#F8F8F8",
    padding: "0px 16px 0px 16px",
    fontWeight: 500,
    textAlign: "left",
    fontSize: 14,
    color: "#2c3e50",
    position: "sticky",
    top: 0,
    zIndex: 1,
});
export const TableHeaderCellColor = styled("div", {
    backgroundColor: "#FFF",
    padding: 5,
    fontWeight: 500,
    textAlign: "left",
    fontSize: 14,
    color: "#2c3e50",
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: 6,
    "&:hover": {
        backgroundColor: "#e1e9fa",
        color: "#0148d6",
    },
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});

export const TableHeaderRow = styled("div", {
    display: "flex",
    height: 30,
    justifyContent: "left",
    alignItems: "center",
    borderRadius: 6,
    padding: '0px 4px',
    fontSize: 14,
    fontWeight: 500,
})
export const AddHiddenColumn = styled("div", {
    fontSize: 22,
    color: '#0055FF',
    cursor: "pointer",
    marginLeft: 38
})

export const Footer = styled('div',{
    position: "fixed",
    bottom: 0,
    display: "flex",
    width: "100%",
    height: 44,
    padding: "6px 341px 6px 16px",
    alignItems: "center",
    flexShrink: 0,
    borderTop: "1px solid #D8D8D8",
    background: "#FFF"
})
export const ColPage = styled("div", {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    gap: 8,
    flexWrap: "wrap",
    height: 30
})
export const ColPageMenu = styled("div", {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    gap: 8,
    flexWrap: "wrap",
    padding: 5,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "#e1e9fa",
        color: "#0148d6",
        padding: 5,
        borderRadius: 4
    },
})
export const TruncatedText = styled('div',{
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    wordWrap: 'break-word',
    whiteSpace: "break-spaces"
});
